/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Extra_Activity_SearchingInputs */

const en_us2_coach_extra_activity_searching = /** @type {(inputs: Coach_Extra_Activity_SearchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Looking up exercises…`)
};

const pt_br2_coach_extra_activity_searching = /** @type {(inputs: Coach_Extra_Activity_SearchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procurando exercícios…`)
};

const es_419_coach_extra_activity_searching = /** @type {(inputs: Coach_Extra_Activity_SearchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscando ejercicios…`)
};

const pt_pt2_coach_extra_activity_searching = /** @type {(inputs: Coach_Extra_Activity_SearchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A procurar exercícios…`)
};

const fr_fr2_coach_extra_activity_searching = /** @type {(inputs: Coach_Extra_Activity_SearchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recherche d'exercices…`)
};

const de_de2_coach_extra_activity_searching = /** @type {(inputs: Coach_Extra_Activity_SearchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suche Übungen…`)
};

const it_it2_coach_extra_activity_searching = /** @type {(inputs: Coach_Extra_Activity_SearchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerco esercizi…`)
};

/**
* | output |
* | --- |
* | "Looking up exercises…" |
*
* @param {Coach_Extra_Activity_SearchingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_extra_activity_searching = /** @type {((inputs?: Coach_Extra_Activity_SearchingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Extra_Activity_SearchingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_extra_activity_searching(inputs)
	if (locale === "es-419") return es_419_coach_extra_activity_searching(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_extra_activity_searching(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_extra_activity_searching(inputs)
	if (locale === "de-DE") return de_de2_coach_extra_activity_searching(inputs)
	if (locale === "it-IT") return it_it2_coach_extra_activity_searching(inputs)
	return en_us2_coach_extra_activity_searching(inputs)
});
export { coach_extra_activity_searching as "coach-extra.activity_searching" }